import { Pane, Heading, Paragraph, UnorderedList, ListItem } from 'evergreen-ui';

const PrivacyPage = () => {
  return (
    <Pane padding={24} background="tint1">
      <Heading size={800} marginBottom={8}>Informativa Privacy</Heading>

      <Paragraph size={400} marginBottom={12}>
        Questa informativa descrive come Casa Letizia (P.IVA 13037730010) raccoglie, usa, conserva e condivide i dati personali degli utenti del sito.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Titolare del trattamento</Heading>
      <Paragraph size={400} marginBottom={12}>
        Casa Letizia GAAG
        <br />
        Sede Legale: Via Vandalino 25, 10093 Collegno (TO)
        <br />
        P.IVA: 13037730010
        <br />
        Contatti: dvessio7@hotmail.com
      </Paragraph>

      <Heading size={600} marginBottom={8}>Dati raccolti</Heading>
      <Paragraph size={400} marginBottom={8}>
        A seconda delle funzionalità usate (riservate agli utenti loggati autorizzati), possiamo raccogliere:
      </Paragraph>
      <UnorderedList marginBottom={12}>
        <ListItem>dati di account: email, password (hashata lato server), nome, cognome, ruolo, recapiti di residenza e contatti di emergenza;</ListItem>
        <ListItem>dati anagrafici, personali e documenti educativi/sanitari dei "guest" (ospiti) gestiti dall'app;</ListItem>
        <ListItem>dati e turni di presenza dei volontari attivi nella struttura;</ListItem>
        <ListItem>file e documenti caricati tramite gestione allegati (PEI, carte d'identità, curriculum);</ListItem>
        <ListItem>log tecnici e dati di connessione, cookie e identificatori di dispositivo;</ListItem>
        <ListItem>comunicazioni inviate/ricevute tramite il servizio (annunci, comunicazioni interne, diario).</ListItem>
      </UnorderedList>

      <Heading size={600} marginBottom={8}>Finalità e basi giuridiche</Heading>
      <UnorderedList marginBottom={12}>
        <ListItem>fornire e mantenere il servizio (es. autenticazione, accesso protetto) — base: esecuzione del contratto o interesse legittimo;</ListItem>
        <ListItem>gestione dei rapporti con ospiti, volontari e collaboratori (adempimenti contrattuali e obblighi normativi);</ListItem>
        <ListItem>gestione degli upload e conservazione documentale — base: esecuzione del servizio o consenso quando richiesto;</ListItem>
        <ListItem>invio di comunicazioni relative al servizio — base: esecuzione del contratto o consenso per comunicazioni di marketing;</ListItem>
        <ListItem>adempimento di obblighi legali (es. conservazione fiscale o contabile).</ListItem>
      </UnorderedList>

      <Heading size={600} marginBottom={8}>Cookie e terze parti</Heading>
      <Paragraph size={400} marginBottom={12}>
        Per i cookie e le tecnologie di tracciamento si rimanda alla <a href="/cookie-policy">Cookie Policy</a>. Il sito utilizza cookie tecnici (es. sessione PHPSESSID) e, se acconsentito, cookie analitici, di marketing o di preferenze.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Conservazione</Heading>
      <Paragraph size={400} marginBottom={12}>
        I dati personali saranno conservati per il tempo necessario alle finalità per cui sono stati raccolti e comunque in conformità alla normativa vigente. Periodi tipici: dati account fino a cancellazione, dati di servizio necessari per obblighi legali fino ai termini previsti dalla legge.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Diritti degli interessati</Heading>
      <Paragraph size={400} marginBottom={12}>
        Hai diritto di chiedere l'accesso, la rettifica, la cancellazione, la portabilità, la limitazione del trattamento e di opporti al trattamento dei tuoi dati. Per esercitare i diritti contatta il titolare agli estremi sopra indicati. Hai inoltre il diritto di proporre reclamo al Garante per la protezione dei dati personali.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Sicurezza</Heading>
      <Paragraph size={400} marginBottom={12}>
        Adottiamo misure tecniche e organizzative ragionevoli per proteggere i dati personali (come hashing per non mostrare mai le password in chiaro e protocollo HTTPS in produzione). Tuttavia non esiste trasmissione via internet completamente sicura; segnala eventuali violazioni al titolare.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Note</Heading>
      <Paragraph size={400} marginBottom={12}>
        Se per le attività è richiesto il trattamento di categorie particolari di dati (come salute, giudiziari), ciò avverrà solo nei casi previsti dalle legge e con idonea base giuridica; tali trattamenti saranno segnalati in modo specifico all'interno dell'applicativo al momento dell'inserimento.
      </Paragraph>
      <Paragraph size={400} marginBottom={12}>
        Versione della Policy: 2.0 del 27/03/2026
      </Paragraph>
      <Paragraph size={400} marginBottom={12}>
        Il fornitore del sito web non è responsabile della redazione o conformità legale delle policy (Privacy, Cookie, Termini e Condizioni), che restano a carico del committente. Il fornitore si limiterà alla loro integrazione tecnica sul sito.
      </Paragraph>

    </Pane>
  );
};

export default PrivacyPage;
